export default "__VITE_ASSET__DzSIAv5R__"